export const LECTURE_ROUTES = {
  list: '/lectures',
  detail: '/lectures/detail',
};
